import { useEffect, useState } from 'react'
import { Row, Col, Button, Card, FormControl, Alert, Modal } from 'react-bootstrap'
import { useSelector, useDispatch } from 'react-redux'
import CheckoutForm from '../CheckoutForm'
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import API from '../../api/api'
import Actions from '../../redux/actions'
import SkipSignUp from '../SkipSignUp';

const stripePromise = loadStripe(process.env.NODE_ENV === 'production' ? "pk_live_51Kw3QQFHklCQeNE23WarXvigDO9oSnKcHqJ5WPUGywBefvUUTn4Iz83k3wPfbAAtkb6sUkwnxDi8E5LYYIG9dqpK00jhlEsxll" : "pk_test_51Kw3QQFHklCQeNE2UB78FF0zONs3TtVbz7mu8wzi3UcpjDjEPWfEXk3li2TgtpVBvwDULHu3mrWDb6R8AccaSu8p00xA56Tcen");

export default function SignupCheckout(props) {

    const [clientSecret, setClientSecret] = useState("");
    const packageType = useSelector(state => state.packageType)
    const dispatch = useDispatch()
    const [quantity, setQuantity] = useState('1')
    const [loading, setLoading] = useState(true)
    const [showSuccess, setShowSuccess] = useState(false)
    const [showErr, setShowErr] = useState(false)
    const [oneMonth, setOneMonth] = useState()
    const [couponCode, setCouponCode] = useState('')
    const [codeApplied, setCodeApplied] = useState(null)
    const [couponErr, setCouponErr] = useState(false)
    const signupErr = useSelector(state => state.signupError)
    const [showModal, setShowModal] = useState()
    useEffect(() => {
        _getClientSecret()
        const now = new Date()
        now.setMonth(now.getMonth() + 1)
        setOneMonth(now)

        const params = new URLSearchParams(window.location.search)
        const promo = params.get('promo')
        if (promo) {
            _applyPromo(promo)
        }
    }, [])


    const _setPayment = async (e) => {

        if (e.setupIntent?.payment_method) {
            const paymentMethod = e.setupIntent.payment_method


            const data = await API.subscribe(Number(quantity), packageType === 'LIFETIME', codeApplied?._id)
            if (!data.err) {
                setShowSuccess(true)
                await API.updatePaymentMethod(paymentMethod)
                const res = await API.getUser()
                dispatch(Actions.setUser(res.user))
            } else {
                setShowErr(true)
            }
        } else {
            setShowErr(true)
        }
    }

    const _applyPromo = async (code) => {
        setCouponErr(false)
        setCouponCode(code)
        const res = await API.checkCouponCode(code)
        if (res.isError) {
            setCouponErr(true)
        } else {
            setCodeApplied(res.coupon)
        }
    }


    const _checkCoupon = async () => {
        setCouponErr(false)

        const res = await API.checkCouponCode(couponCode)
        if (res.isError) {
            setCouponErr(true)
        } else {
            setCodeApplied(res.coupon)
        }
    }


    const _getClientSecret = async () => {
        setLoading(true)
        const res = await API.setupPaymentMethod()
        setClientSecret(res.client_secret)
        setLoading(false)
    }

    const _setQuantity = (e) => {
        setQuantity(e.target.value)
        if (isNaN(e.target.value)) {
            dispatch(Actions.setSignupError(true))
            return
        }

        const num = Number(e.target.value)
        if (num < 1) {
            dispatch(Actions.setSignupError(true))
            return
        }
        if (!Number.isInteger(num)) {
            dispatch(Actions.setSignupError(true))
            return
        }

        dispatch(Actions.setSignupError(false))


    }

    return (
        <Col md={10} className={`bg-white shadow rounded my-auto mx-auto animate__animated animate__fadeIn`}>
            <Row className='p-5 justify-content-center'>
                <Col className='justify-content-center' md={6}>
                    {packageType !== 'LIFETIME' && <>
                        <h2 className='text-center text-primary'>Start Your Free Trial</h2>
                        <p className='text-center'>You will be charged <span className='text-primary weight-bold'>$3.49</span><small> / month</small> per device and can adjust this number any time in your settings.  </p>

                        <Row className='my-5 justify-content-center'>
                            <Col md={6} className='my-auto'>
                                <p className='my-auto ms-auto text-end'><b>PromoCode: </b></p>
                            </Col>
                            <Col md={4}>
                                <FormControl type='text' value={couponCode} disabled={codeApplied !== null} onChange={(e) => setCouponCode(e.target.value)} placeholder='PROMO' />
                            </Col>
                            <Col md={2}>
                                <Button variant='primary' disabled={codeApplied || couponCode === ''} onClick={_checkCoupon}>Apply</Button>
                            </Col>
                        </Row>
                        {couponErr && <p className='weight-bold my-0 text-danger'>This is not a valid coupon</p>}
                        {codeApplied !== null && <p className='weight-bold mb-0 text-success'>CODE APPLIED: {codeApplied.monthlyDescr}</p>}

                        <Row className='my-5 justify-content-center'>
                            <Col md={6} className='my-auto'>
                                <p className='my-auto ms-auto text-end'><b>Device Pairs: </b></p>
                                {!isNaN(quantity) && <p className='my-auto ms-auto text-end'><small>{Number(quantity) * 2} Devices</small></p>}
                            </Col>
                            <Col md={2}>
                                <FormControl type='text' value={quantity} disabled={showSuccess} onChange={(e) => _setQuantity(e)} placeholder='1' />
                            </Col>
                        </Row>

                        <Row className='my-5 justify-content-center'>
                            <Col md={6} className='my-auto'>
                                <p className='my-auto ms-auto text-end'><b>Today's Bill: </b></p>
                            </Col>
                            <Col md={4} className='my-auto'>
                                <p className='text-primary my-auto weight-bold'>$0.00 </p>
                            </Col>
                        </Row>
                        {quantity !== '' && !isNaN(quantity) && !signupErr && <Row className='my-5 justify-content-center'>
                            <Col md={6} className='my-auto'>
                                <p className='my-auto ms-auto'><b>Monthly Bill Starting {oneMonth?.toLocaleDateString('en-US', { dateStyle: 'medium' })}: </b></p>
                            </Col>
                            <Col md={4} className='my-auto'>
                                <p className={`text-primary my-auto ${codeApplied === null && 'weight-bold'} ${codeApplied !== null && 'line'}`}>${((Number(quantity) * 349) / 100).toFixed(2)} <small>/ mo</small> </p>
                                {codeApplied !== null && <p className={`text-primary my-auto weight-bold`}>${(((Number(quantity) * 349) - codeApplied.monthlyOff) / 100).toFixed(2)} <small>/ mo</small> </p>}
                            </Col>
                        </Row>}
                    </>}
                    {packageType === 'LIFETIME' && <>
                        <p className='text-center'>Great choice on the lifetime package! This package comes with <b className='text-primary'>3 devices for life!</b> If you need more devices than this, you can always add more in your settings!  </p>
                        <Row className='my-5 justify-content-center'>
                            <Col md={6} className='my-auto'>
                                <p className='my-auto ms-auto'><b>PromoCode: </b></p>
                            </Col>
                            <Col md={3}>
                                <FormControl type='text' value={couponCode} disabled={codeApplied !== null} onChange={(e) => setCouponCode(e.target.value)} placeholder='PROMO' />
                            </Col>
                            <Col md={3}>
                                <Button variant='primary' disabled={codeApplied || couponCode === ''} onClick={_checkCoupon}>Apply</Button>
                            </Col>
                        </Row>
                        {codeApplied !== null && <p className='weight-bold mb-0 text-success'>CODE APPLIED: {codeApplied.lifeTimeDescr}</p>}
                        {couponErr && <p className='weight-bold mb-0 text-danger'>This is not a valid coupon</p>}
                        <Row className='my-5 justify-content-center'>
                            <Col md={5} className='my-auto'>
                                <p className='my-auto'><b>One Time Payment: </b></p>
                            </Col>
                            <Col md={4} className='my-auto'>
                                <p className={`text-primary my-auto ${codeApplied === null && 'weight-bold'} ${codeApplied !== null && 'line'}`}>$125.00  </p>
                                {codeApplied !== null && <p className={`text-primary my-auto weight-bold`}>${((12500 - codeApplied.lifeTimeOff) / 100).toFixed(2)}  </p>}
                            </Col>
                        </Row>
                    </>}
                </Col>

                {!showSuccess && <Col md={6}>


                    {!loading && !showSuccess && packageType && <Elements stripe={stripePromise} options={{ clientSecret: clientSecret }}>

                        <CheckoutForm next={_setPayment} isLifeTime={packageType === 'LIFETIME'} />

                    </Elements>}

                </Col>}
                {showErr && <Alert variant='danger' className='text-center my-3'> That didn't work, try a different card. </Alert>}

                {showSuccess && <Alert variant='success' className='text-center my-3'> You have successfully {packageType !== 'LIFETIME' ? `subscribed for ${quantity} devices.` : `paid for 3 lifetime devices.`} </Alert>}
                <Row>
                    <Col md={6} className='mx-auto'>
                        {showSuccess && <Button variant='primary' onClick={() => dispatch(Actions.setSignupStep(5))}>Next</Button>}

                    </Col>
                </Row>
            </Row>
            <div className='text-center mb-2'>
                {!showSuccess && <Button variant='link noDecoration mb-2' onClick={() => setShowModal(true)}>Skip For Now</Button>}
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)} size='md'>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Skipping Payment</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <SkipSignUp />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="link noDecoration" onClick={() => dispatch(Actions.setSignupStep(5))}>
                        Confirm Skip
                    </Button>
                    <Button variant="primary" onClick={() => setShowModal(false)}>
                        Never mind
                    </Button>
                </Modal.Footer>

            </Modal>
        </Col>
    )
}